(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8402],{

/***/ 2746:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/launch-calendar",
      function () {
        return __webpack_require__(28757);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ launch_calendar; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 52 modules
var SanityContentSlot = __webpack_require__(54331);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useProductClickHandling.ts
var useProductClickHandling = __webpack_require__(7362);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./ui/components/SanityImage.tsx
var SanityImage = __webpack_require__(86468);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
;// CONCATENATED MODULE: ./ui/components/LaunchCalendar/LaunchCalendarTile.tsx








var LaunchCalendarTile = function(props) {
    var ref, ref1;
    var item = props.item, itemListId = props.itemListId, itemListName = props.itemListName, position = props.position;
    var ref2 = (0,useGA4Events/* useGA4Events */.tL)(), setProduct = ref2.setProduct, fireClickProductImage = ref2.fireClickProductImage;
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), regionCode = ref3.regionCode, _staticFeatures = ref3.staticFeatures, searchLocalImagesOnDropCalendar = _staticFeatures.searchLocalImagesOnDropCalendar, showHeaderSubHeaderProductDetail = _staticFeatures.showHeaderSubHeaderProductDetail;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var date = new Date(item.launchDate);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var getImageURL = function() {
        var baseURL = "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/".concat(item.masterId, "/").concat(item.color);
        var imageViewPath = (item === null || item === void 0 ? void 0 : item.imageView) ? "/".concat(item.imageView) : "";
        var regionPath = searchLocalImagesOnDropCalendar ? "/fnd/".concat(regionCode) : "";
        return "".concat(baseURL).concat(imageViewPath).concat(regionPath, "/fmt/png");
    };
    var productUrl = !item.disableProductLink && (item === null || item === void 0 ? void 0 : item.masterId) ? (0,buildProductUrl/* buildProductUrl */.B)(item.masterId, item.productName, {
        color: item.color
    }) : item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileRoot */.OH2, {
        fill: "content",
        layout: "stack",
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            onClick: function() {
                fireClickProductImage(getImageURL());
                (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(item.masterId, "_").concat(item.color), {
                    lid: itemListId,
                    lname: itemListName,
                    idx: position
                });
                setProduct(item);
            },
            children: [
                item.appExclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileFloat */.V_6, {
                    justify: "start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Badge */.Cts, {
                        label: t("appExclusive")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TileContent */.Y2I, {
                    justify: "center",
                    align: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TileBody */.hnB, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileHeading */.ZRD, {
                                    balance: true,
                                    size: {
                                        mobile: "sm",
                                        tablet: "base",
                                        desktop: "sm"
                                    },
                                    children: showHeaderSubHeaderProductDetail ? item.header : item.launchCalendarProductName
                                }),
                                showHeaderSubHeaderProductDetail && item.subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileDescription */.NhG, {
                                    size: "sm",
                                    className: "text-puma-gray-60 line-clamp-2",
                                    children: item.subHeader
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileDescription */.NhG, {
                                    size: "sm",
                                    children: (item === null || item === void 0 ? void 0 : item.launchCopy) ? item.launchCopy : "".concat(t("available").toUpperCase(), " ").concat(t("dateFormat", {
                                        day: day,
                                        month: month,
                                        year: year
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileFooter */.HTg, {
                            children: productUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                                label: (item === null || item === void 0 ? void 0 : item.ctaCopy) ? item.ctaCopy : t("learnMore"),
                                target: item.appExclusive ? "_blank" : "_self",
                                variant: "secondary",
                                href: productUrl
                            }) : null
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileMedia */.uIU, {
                    children: item.productImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                        source: item.productImage
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: getImageURL(),
                            alt: ""
                        })
                    })
                }),
                productUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkInvBlock */.p67, {
                    target: item.appExclusive ? "_blank" : "_self",
                    href: productUrl,
                    focusable: false
                }) : null
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/LaunchCalendar/LaunchCalendarList.tsx




var LaunchCalendarList = function(props) {
    var itemListId = props.itemListId || "";
    var itemListName = props.itemlistName || "";
    // To differentiate in which LaunchCalendarList the click occurred.
    var setIsProductClicked = (0,useProductClickHandling/* useProductClickHandling */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                transform: "uppercase",
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: props.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Grid */.rjZ, {
                columns: {
                    initial: 1,
                    tablet: 2,
                    desktop: 4
                },
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    onClick: function() {
                        return setIsProductClicked(true);
                    },
                    children: props.items.map(function(item, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchCalendarTile, {
                            item: item,
                            position: idx,
                            itemListId: itemListId,
                            itemListName: itemListName
                        }, idx);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./hooks/useContentSplitByMonth.ts

var useContentSplitByMonth = function(items) {
    var itemsSeparatedByMonth = items.filter(function(item) {
        return !item.released;
    }).reduce(function(result, item) {
        var ref;
        var date = new Date(item.launchDate);
        var year = date.getFullYear();
        var longMonth = date.toLocaleString("en-GB", {
            month: "long"
        });
        // set object key as current month + 1 (0 is jan) and then append the year
        // this will keep the order of months eg: 202312, 202401
        var month = date.getMonth() + 1;
        var monthNumStr = month < 10 ? "0".concat(month) : "".concat(month);
        var yearMonthIndex = parseInt("".concat(year).concat(monthNumStr));
        result[yearMonthIndex] = {
            year: year,
            month: date.getMonth(),
            longMonth: longMonth.toLowerCase(),
            items: (0,_to_consumable_array/* default */.Z)(new Set((ref = result[yearMonthIndex]) === null || ref === void 0 ? void 0 : ref.items)).concat([
                item
            ])
        };
        return result;
    }, {});
    return Object.values(itemsSeparatedByMonth);
};

// EXTERNAL MODULE: ./hooks/useItemListViewEvent.ts
var useItemListViewEvent = __webpack_require__(35538);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
;// CONCATENATED MODULE: ./ui/pages/LaunchCalendar.tsx













var LaunchCalendarPage = function(param) {
    var page = param.page, items = param.items;
    var ref, ref1;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var country = (0,useSiteConfig/* useSiteConfig */.N)().country;
    var releasedItems = items.filter(function(item) {
        return item.released;
    });
    releasedItems.sort(function(a, b) {
        return b.launchDate.localeCompare(a.launchDate);
    });
    var futureItemsByMonth = useContentSplitByMonth(items);
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var listItems = (0,react.useMemo)(function() {
        if (!items) return [];
        return items.map(function(product, index) {
            return (0,analytics/* transformListProductToAnalyticsItem */.pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: undefined
                },
                itemListId: page._id,
                itemListName: page._type,
                index: index
            });
        });
    }, [
        items,
        currency.code,
        page._id,
        page._type
    ]);
    var itemListId = page._id;
    var itemListName = page._type;
    (0,useItemListViewEvent/* useItemListViewEvent */.t)({
        itemListId: itemListId,
        itemListName: itemListName,
        items: listItems
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.pageTitle,
                description: "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.pageDescription)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                        items: page === null || page === void 0 ? void 0 : page.aboveContent,
                        documentId: page === null || page === void 0 ? void 0 : page._id,
                        slotId: "aboveDropCalendarContent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                        gap: "2xl",
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                    srOnly: true,
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Launch Calendar"
                                    })
                                }),
                                futureItemsByMonth.map(function(group, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchCalendarList, {
                                        items: group.items,
                                        title: country === constants/* SUPPORTED_COUNTRY.JP */.bM.JP ? group.year + "年 " + t(group.longMonth) + "月" : t(group.longMonth) + " " + group.year,
                                        itemListId: itemListId,
                                        itemlistName: itemListName
                                    }, idx);
                                }),
                                releasedItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchCalendarList, {
                                    items: releasedItems,
                                    title: t("outNow"),
                                    itemListId: itemListId,
                                    itemlistName: itemListName
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                        items: page === null || page === void 0 ? void 0 : page.belowContent,
                        documentId: page === null || page === void 0 ? void 0 : page._id,
                        slotId: "belowDropCalendarContent"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./groq/ContentSlots.ts
var ContentSlots = __webpack_require__(18273);
// EXTERNAL MODULE: ./groq/objects/CallToActionObject.ts
var CallToActionObject = __webpack_require__(28008);
// EXTERNAL MODULE: ./groq/objects/SanityImageObject.ts + 1 modules
var SanityImageObject = __webpack_require__(14075);
// EXTERNAL MODULE: ./groq/shared/LocaleSeo.ts + 1 modules
var LocaleSeo = __webpack_require__(16138);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
;// CONCATENATED MODULE: ./groq/pages/LaunchCalendarPage.ts





var LaunchCalendarPageQuery = '\n*[_type == "DropCalendarPage" && country == upper($country)][0] {\n  _id,\n  _type,\n  '.concat((0,LocaleSeo/* LocaleSeo */.U)("seo"), ",\n  aboveContent[] ").concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ",\n  belowContent[] ").concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ',\n  "products": products[] | order(launchDate asc) {\n    "_type": "Message",\n    ').concat((0,SanityImageObject/* SanityImageObject */.i)("productImage"), ",\n    color,\n    launchDate,\n    masterId,\n    productId,\n    productName,\n    launchCalendarProductName,\n    ").concat((0,LocaleString/* LocaleString */.E)("launchCopy"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("ctaCopy"), ",\n    ").concat((0,CallToActionObject/* CallToActionObject */.U)("cta[]"), ',\n    availableFrom,\n    availableTo,\n    header,\n    subHeader,\n    appExclusive,\n    disableProductLink,\n    imageView,\n    "released": select(\n      dateTime(launchDate) <= dateTime(now())\n    )\n  }\n}\n');

;// CONCATENATED MODULE: ./pages/[country]/[language]/launch-calendar.tsx





var LaunchCalendar = function() {
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "LaunchCalendarPage",
        query: LaunchCalendarPageQuery
    }), 1), launchCalendarPage = ref3[0];
    var page = launchCalendarPage === null || launchCalendarPage === void 0 ? void 0 : (ref = launchCalendarPage.data) === null || ref === void 0 ? void 0 : ref.content;
    var items = launchCalendarPage === null || launchCalendarPage === void 0 ? void 0 : (ref1 = launchCalendarPage.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.products;
    return page && items ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchCalendarPage, {
        page: page,
        items: items
    }) : null;
};
/* harmony default export */ var launch_calendar = (LaunchCalendar);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1489,9294,2042,6740,769,9774,2888,179], function() { return __webpack_exec__(2746); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);